import React, { useEffect, useState } from "react"
import { Typography } from "@material-ui/core"
import { createStyles, makeStyles } from "@material-ui/core/styles"
import { theme } from "../../../layouts/MainFrame"
import { isDesktop } from "../../../hooks/usePlatform"
import CalculationController from "./CalculationController"
import CalculationDisplayer from "./CalculationDisplayer"
import usePricing from "../../../hooks/usePricing"
import { FormattedMessage } from "react-intl"

const useStyles = makeStyles(() =>
  createStyles({
    wrap: {
      display: "flex",
      flexDirection: "column",
      rowGap: "58px",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      padding: "66px 0 89px",
      [theme.breakpoints.down("sm")]: {
        padding: "37px 12px 38px",
        rowGap: "34px",
      },
    },
    h2: {
      color: theme.palette.primary.main,
    },
    viewer: {
      display: "flex",
      flexDirection: () => (isDesktop() ? "row" : "column"),
      height: "301px",
      borderRadius: "20px",
      boxShadow: "0px 24px 40px rgba(0, 0, 0, 0.05)",
      [theme.breakpoints.down("sm")]: {
        height: "475px",
      },
    },
  })
)
interface PricingCalculatorProps {
  inquire: () => void
}

export default function PricingCalculator({ inquire }: PricingCalculatorProps) {
  const classes = useStyles()
  const { visitor, onChangeCalculating, recommendedPricing, categories } = usePricing()

  const [categoryIndex, setCategoryIndex] = useState(0)
  const onChange = (value: number) => onChangeCalculating(categories[categoryIndex].type, value)

  useEffect(() => {
    onChange(visitor)
  }, [categoryIndex])

  return (
    <div className={classes.wrap}>
      <Typography variant={"h2"} className={classes.h2}>
        <FormattedMessage id={"pricing_calculator_title"} />
      </Typography>
      <div className={classes.viewer}>
        <CalculationController
          categories={categories}
          categoryIndex={categoryIndex}
          setCategoryIndex={setCategoryIndex}
          visitor={visitor}
          onChange={onChange}
          recommendedPricing={recommendedPricing}
        />
        <CalculationDisplayer inquire={inquire} recommendedPricing={recommendedPricing} />
      </div>
    </div>
  )
}
